import { BrazilianState } from '@/constants/brazilianStates'
import { MultiLanguageString } from '@/lib/api/stays/types/shared-types'
import type { StaysPropertyFormOutput } from '@/schemas/stays/staysPropertySchema'
import type { StProperty } from '@/types'
import { getLocalizedText } from './getLocalizedText'

export type ImageJson = {
  url: string
  is_primary: boolean | null
  stays_id: string | null
  file?: File | undefined
}

export type StaysAddressJson = {
  countryCode: string
  stateCode: BrazilianState
  city: string
  region: string
  street: string
  streetNumber: string
  zip: string
}

/**
 * Get default values for property form
 */
export const getDefaultValues = (
  st_property?: StProperty | null
): StaysPropertyFormOutput => {
  const addressObject = st_property?.address as StaysAddressJson | undefined
  return {
    _idtype: st_property?._idtype || '',
    internalname: st_property?.internalname || '',
    _mstitle:
      getLocalizedText(
        st_property?._mstitle as MultiLanguageString | undefined
      ) || '',
    address: {
      countryCode: 'BR',
      stateCode: addressObject?.stateCode || '',
      city: addressObject?.city || '',
      region: addressObject?.region || '',
      street: addressObject?.street || '',
      streetNumber: addressObject?.streetNumber || '',
      zip: addressObject?.zip || '',
    },
    _msdesc:
      getLocalizedText(
        st_property?._msdesc as MultiLanguageString | undefined
      ) || '',
    images: st_property?.images || [],
    status: st_property?.status || 'draft',
  }
}
